import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import Classes from "@/pages/Classes";
import ClassDetail from "@/pages/ClassDetail";
import Schedule from "@/pages/Schedule";
import GroupTraining from "@/pages/GroupTraining";
import About from "@/pages/About";
import FAQs from "@/pages/FAQs";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import Policies from "@/pages/Policies";
import Register from "@/pages/Register";
import RegistrationSuccess from "@/pages/RegistrationSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function WithLayout({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop />
            <Toaster position="top-right" richColors />
            <Routes>
              {/* Public routes with layout */}
              <Route path="/" element={<WithLayout><Home /></WithLayout>} />
              <Route path="/classes" element={<WithLayout><Classes /></WithLayout>} />
              <Route path="/classes/:slug" element={<WithLayout><ClassDetail /></WithLayout>} />
              <Route path="/schedule" element={<WithLayout><Schedule /></WithLayout>} />
              <Route path="/group-training" element={<WithLayout><GroupTraining /></WithLayout>} />
              <Route path="/about" element={<WithLayout><About /></WithLayout>} />
              <Route path="/faqs" element={<WithLayout><FAQs /></WithLayout>} />
              <Route path="/testimonials" element={<WithLayout><Testimonials /></WithLayout>} />
              <Route path="/contact" element={<WithLayout><Contact /></WithLayout>} />
              <Route path="/policies" element={<WithLayout><Policies /></WithLayout>} />
              <Route path="/register/:sessionId" element={<WithLayout><Register /></WithLayout>} />
              <Route path="/registration-success/:id" element={<WithLayout><RegistrationSuccess /></WithLayout>} />

              {/* Admin routes (no site layout) */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />

              {/* 404 fallback */}
              <Route path="*" element={<WithLayout><Home /></WithLayout>} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
